<script>
  import Button from '@components/Button.svelte';
  import GroupAjax from '@ajax/group';
  import SectionAjax from '@ajax/section';

  import jQuery from 'jquery';
  import QuizOption from '@app-components/group/QuizOption.svelte';
  import { createEventDispatcher } from 'svelte';
  import { browser } from '$app/environment';
  import { getGroupStore } from '@stores/group';
  let sectionsStore = getGroupStore('sectionsStore');

  const dispatch = createEventDispatcher();
  export let mobile = false;
  export let group;
  export let withQuiz = false;
  export let expanded = false;
  let quiz = null;
  let topShadow = false;
  let bottomShadow = false;
  let owlCarouselElement = null;
  let sections = false;
  let selectedSectionIndex = null;
  let questions = [];
  let sectionsList = [];
  let finishButtonEnabled = false;
  $: if (quiz) {
    if (quiz.sections.length > 0) {
      sections = true;
      sectionsList = quiz.sections;
      if (selectedSectionIndex == null) {
        selectedSectionIndex = firstUnansweredSection();
      }
    }
    if (sections) {
      questions = sectionsList[selectedSectionIndex].questions;
      finishButtonEnabled =
        sectionsList.filter(function (s) {
          return (
            s.questions.filter(function (x) {
              return x.r;
            }).length > 0
          );
        }).length > 0;
    } else {
      questions = quiz.questions;
      finishButtonEnabled =
        questions.filter(function (x) {
          return x.r;
        }).length > 0;
    }
  }

  const unansweredIndexes = function () {
    let indexes = [];
    questions.forEach(function (item, index) {
      if (item.r == null) {
        indexes.push(index);
      }
    });
    return indexes;
  };

  // const answeredIndexes = function () {
  //   let indexes = [];
  //   questions.forEach(function (item, index) {
  //     if (item.r != null) {
  //       indexes.push(index);
  //     }
  //   });
  //   return indexes;
  // };

  const firstUnansweredSection = function () {
    let index = 0;
    sectionsList.every((item) => {
      let count = item.questions.filter(function (x) {
        return x.r == null;
      }).length;

      if (count > 0) {
        return false;
      }
      index = index + 1;
      return true;
    });
    if (index < sectionsList.length) {
      return index;
    } else {
      return sectionsList.length - 1;
    }
  };

  // const lastAnsweredQuestionIndex = function () {
  //   if (answeredIndexes().length == 0) {
  //     return 0;
  //   } else {
  //     return answeredIndexes().slice(-1);
  //   }
  // };

  let updateIndex = function (event) {
    let newIndex = event.item.index;
    if (newIndex != selectedSectionIndex) {
      selectedSectionIndex = newIndex;
    }
  };

  let changeCarouselPositionNext = function () {
    changeCarouselPosition('next');
  };

  let changeCarouselPositionPrev = function () {
    changeCarouselPosition('prev');
  };

  let changeCarouselPosition = function (action) {
    if (action == 'next') {
      owlCarouselElement.trigger('next.owl.carousel');
    } else {
      owlCarouselElement.trigger('prev.owl.carousel');
    }
    setTimeout(setShadowOptions, 50);
    setTimeout(scrollToRequiredDiv, 200);
  };

  let setupOwlCarousel = async function (node) {
    if (!browser) {
      return;
    }
    await import('@utils/owl-carousel');

    let owlCarousel = jQuery(node);
    owlCarouselElement = owlCarousel;
    let setup = function () {
      owlCarousel.owlCarousel({
        loop: false,
        responsiveClass: true,
        margin: 20,
        items: 1,
        dots: false,
        singleItem: true,
        startPosition: 0,
        onChanged: updateIndex,
      });
    };

    setup();
  };

  let maxBigDotsShown = 6;
  const dotSizeClass = function (i) {
    var start = selectedSectionIndex - maxBigDotsShown + 1;

    var end = start + maxBigDotsShown;

    if (start < 0) {
      start = 0;
      end = start + maxBigDotsShown;
    }
    let requiredClass = '';
    if (i >= start && i < end) {
      requiredClass = 'regular';
    } else if (i == start - 1 || i == end) {
      requiredClass = 'small';
    } else if (i == start - 2 || i == end + 1) {
      requiredClass = 'smallest';
    } else {
      requiredClass = 'hidden';
    }
    return requiredClass;
  };

  const setShadowOptions = async function () {
    let questionsDiv = document.getElementById('quiz-questions');
    let scrollEnabled = questionsDiv.scrollHeight > questionsDiv.clientHeight;
    if (scrollEnabled) {
      topShadow = questionsDiv.scrollTop > 20;
      bottomShadow = questionsDiv.scrollHeight - questionsDiv.scrollTop - questionsDiv.clientHeight > 20;
    } else {
      topShadow = null;
      bottomShadow = null;
    }
  };

  const toggleExpand = function () {
    expanded = !expanded;
    if (expanded) {
      loadQuiz();
      setTimeout(scrollToRequiredDiv, 1);
      setTimeout(setShadowOptions, 50);
    }
  };

  const getFirstUnanswered = function () {
    const questionLastIndex = questions.length - 1;
    const targetIndexes = unansweredIndexes();
    if (targetIndexes.length == 0) {
      return questionLastIndex;
    } else {
      return targetIndexes[0];
    }
  };
  const loadQuiz = async function () {
    quiz = null;
    let response = await GroupAjax.quiz(group);
    if (response.quiz && (response.quiz.questions.length > 0 || response.quiz.sections.length > 0)) {
      quiz = response.quiz;
      withQuiz = true;
      setTimeout(jumpToRequiredPosition, 200);
      setTimeout(scrollToRequiredDiv, 300);
    }
  };

  const scrollToRequiredDiv = function () {
    if (expanded) {
      var targetIndex = getFirstUnanswered();
      const elem = document.getElementById(`quiz-question-${targetIndex}`);
      if (elem) {
        elem.scrollIntoView({ behavior: 'instant', block: 'start', inline: 'start' });
      }
    }
  };

  const jumpToRequiredPosition = function () {
    if (sections) {
      if (owlCarouselElement) {
        owlCarouselElement.trigger('to.owl.carousel', [firstUnansweredSection(), 0]);
      }
    }
  };
  export const saveAnswer = async function (questionId, answer) {
    var response = await GroupAjax.answerQuiz(group, quiz, { question_id: questionId, r: answer });
    quiz = response;
  };

  const submitAnswer = async function (question, answer) {
    if (answer) {
      dispatch('clicked', { question: question });
    } else {
      saveAnswer(question.id, answer);
    }
  };
  const markAsFinished = async function () {
    await GroupAjax.finishQuiz(group, quiz, {});
    sectionsStore.set(await SectionAjax.fetch(group));
    withQuiz = false;
    quiz = null;
  };

  // const toggleBodyScrollbar = function () {
  //   if (expanded) {
  //     jQuery('body').css({ position: 'fixed', 'overflow-y': 'scroll' });
  //   } else {
  //     jQuery('body').css({ position: 'unset', 'overflow-y': 'scroll' });
  //   }
  // };
  loadQuiz();
</script>

<style style="text/scss" lang="scss">
  @import '../../vendor/design-system.scss';

  // Styles for desktop-based add button:
  .fixed-quiz-container.expanded {
    .top-section.shadow {
      box-shadow: 0px 8px 24px -8px rgba(94, 81, 142, 0.09);
    }
    .bottom-section.shadow {
      box-shadow: 0px -8px 24px -8px rgba(94, 81, 142, 0.09);
    }
  }
  .fixed-quiz-container {
    position: fixed;
    z-index: 20;
    background: #f5f3fc;

    .arrow-action {
      margin-bottom: 30px;
      cursor: pointer;
      img {
        width: 16px;
        rotate: 90deg;
      }
    }

    .top-section {
      font-style: normal;
      .title {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 12px;
        color: #1a1a1a;
        font-size: 20px;
        line-height: 30px;
        font-weight: 700;

        .heading {
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          display: -webkit-inline-box;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .worker-women {
          width: 24px;
        }
        .icon-arrow {
          width: 16px;
          cursor: pointer;
        }
        div {
          flex: 1;
        }
      }
      .description {
        color: #7f7f7f;
        font-size: 14px;
        line-height: 18px;
        margin-top: 12px;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        display: -webkit-inline-box;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    .option-wrapper {
      // margin: 24px 0; /* please check and update if required. commented for now */
      font-size: 14px;
      line-height: 20px;
      overflow-y: auto;
    }

    .bottom-section {
      width: 100%;
      background: #f5f3fc;
      position: absolute;
      left: 0;
      bottom: 0;
      padding: 20px 0 20px;
      z-index: 2;
      .sections-menu {
        display: flex;
        flex-direction: row;
        gap: 10px;
        margin: 10px;
        :global(button) {
          margin: 0px auto 0 !important;
          width: 78px !important;
          height: 44px !important;
        }
        .middle-bottom {
          width: calc(100% - 156px);
          .section-name {
            color: var(--neutral-dark, #1a1a1a);
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            margin-bottom: 6px;
            line-height: 20px; /* 142.857% */
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            display: -webkit-inline-box;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
        .section-action {
          display: inline-flex;
          padding: 14px 24px;
          justify-content: center;
          align-items: center;
          border-radius: 16px;
          border: 2px solid var(--neutral-input-gray, #ececec);
          cursor: pointer;
          &.without-action {
            visibility: hidden;
          }
          &:hover {
            background: black;
            color: white;
            border: 2px solid black;
            outline: none;

            svg {
              path {
                stroke: white;
                fill: white;
              }
            }
          }
        }
      }
      .more {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        .dot {
          width: 6px;
          height: 6px;
          background: #d6cfea;
          border-radius: 50%;
          &.selected {
            background: var(--neutral-dark, #1a1a1a);
          }
          &.small {
            width: 4px;
            height: 4px;
          }
          &.smallest {
            width: 2px;
            height: 2px;
          }
          &.hidden {
            display: none;
          }
        }
      }
      :global(button) {
        max-width: 206px;
        margin: 40px auto 0;
        display: block;
      }
      &.disabled {
        box-shadow: 0px -8px 24px 0px rgba(94, 81, 142, 0.09);
        :global(button) {
          opacity: 0.5;
        }
      }
    }
  }

  .mobile.fixed-quiz-container {
    bottom: 0px;
    padding: 0 0 108px;
    margin-left: -30px;
    width: 100%;
    border-radius: 30px 30px 0px 0px;
    box-shadow: 8px 0px 20px 0px rgba(0, 0, 0, 0.06);
    .top-section {
      padding: 32px 30px 24px;
      height: 154px;
    }
    .option-wrapper {
      padding: 0 30px;
    }

    .description {
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      display: -webkit-inline-box;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    &.collapsed {
      height: 110px; /* will update as per requirement */
      transition-property: 'height';
      transition-duration: 0.5s;
      transition-delay: 0.1s;
      .bottom-section {
        padding: 15px 0 15px !important;
        :global(button) {
          margin: 24px auto 0 !important;
        }
      }
      .option-wrapper {
        overflow: hidden;
      }
    }
    &.expanded {
      height: 75%;
      transition-property: height;
      transition-duration: 0.5s;
      transition-delay: 0.1s;
      .top-section .icon-arrow {
        rotate: 180deg;
        cursor: pointer;
      }
      .option-wrapper {
        height: calc(75dvh - 262px);
        &.with-sections {
          height: calc(75dvh - 252px);
        }
      }
      .bottom-section {
        padding: 15px 0 15px !important;
        .sections-menu {
          :global(button) {
            margin: 0px auto 0 !important;
            width: 78px !important;
            height: 44px !important;
          }
        }
        :global(button) {
          margin: 30px auto 0 !important;
        }
      }
    }
  }

  .desktop.fixed-quiz-container {
    left: 0px;
    top: 0px;
    height: 100%;
    &.collapsed {
      width: 64px;
      padding: 40px 20px;
    }
    &.expanded {
      width: 360px;
      position: fixed;
      padding: 0 0 108px;
      .arrow-action img {
        rotate: -90deg;
      }
      .top-section {
        padding: 40px 40px 30px;
        height: 222px;
      }
      .option-wrapper {
        height: calc(100vh - 350px);
        padding: 0 40px;
        &.with-sections {
          height: calc(100vh - 330px);
        }
      }
    }
  }
</style>

{#if quiz}
  <div class="fixed-quiz-container {expanded ? 'expanded' : 'collapsed'} {mobile ? 'mobile' : 'desktop'}">
    {#if mobile || expanded}
      {#if expanded}
        <div class="top-section {topShadow ? 'shadow' : ''}">
          {#if !mobile}
            <div class="arrow-action">
              <img
                on:click|preventDefault|stopPropagation={toggleExpand}
                on:keydown={toggleExpand}
                src="/images/quiz/arrow.png"
                alt="" />
            </div>
          {/if}
          <div class="title">
            <img class="worker-women" src={quiz.emoji} alt="" />
            <div class="heading">{quiz.heading}</div>
            {#if mobile}
              <img
                on:click|preventDefault|stopPropagation={toggleExpand}
                on:keydown={toggleExpand}
                class="icon-arrow"
                src="/images/quiz/arrow.png"
                alt="" />
            {/if}
          </div>
          <div class="description">
            {sections ? sectionsList[selectedSectionIndex].description : quiz.description}
          </div>
        </div>
        <div
          id="quiz-questions"
          class="option-wrapper purple-scrollbar-thin {sections ? 'with-sections' : ''}"
          on:scroll={setShadowOptions}>
          {#each questions as question, index}
            <QuizOption
              mobile={mobile}
              expanded={expanded}
              question={question}
              questionIndex={index}
              submitAnswer={(q, a) => submitAnswer(q, a)} />
          {/each}
        </div>
        <div class="bottom-section {bottomShadow ? 'shadow' : ''}">
          {#if sections}
            <div class="sections-menu">
              <div class="left-bottom">
                <div
                  on:click|preventDefault|stopPropagation={changeCarouselPositionPrev}
                  on:keydown={changeCarouselPositionPrev}
                  class="section-action {selectedSectionIndex == 0 ? 'without-action' : ''}">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Icon/Solid/Arrowhead&#226;&#128;&#168;/Left">
                      <path
                        id="Arrow"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M11.7682 14.5802C12.1218 14.0852 12.0645 13.3495 11.6402 12.9371L6.56205 8L11.6402 3.06295C12.0645 2.65046 12.1218 1.9148 11.7682 1.41981C11.4147 0.924825 10.7841 0.857947 10.3598 1.27044L4.35982 7.10375C4.13182 7.3254 4 7.65376 4 8C4 8.34624 4.13182 8.6746 4.35982 8.89625L10.3598 14.7296C10.7841 15.1421 11.4147 15.0752 11.7682 14.5802Z"
                        fill="#1A1A1A" />
                    </g>
                  </svg>
                </div>
              </div>
              <div class="middle-bottom">
                <div
                  id="sections"
                  style="text-align: center; display: grid;"
                  class="owl-carousel owl-theme"
                  use:setupOwlCarousel>
                  {#each sectionsList as s}
                    <div class="section-name">
                      {s.heading}
                    </div>
                  {/each}
                </div>

                <div class="more">
                  {#each sectionsList as _, index}
                    <span class="dot {index == selectedSectionIndex ? 'selected' : ''} {dotSizeClass(index)}" />
                  {/each}
                </div>
              </div>
              <div class="right-bottom">
                {#if selectedSectionIndex == sectionsList.length - 1}
                  <Button class="finish-btn" text="Finish!" on:click={markAsFinished} disabled={!finishButtonEnabled} />
                {:else}
                  <div
                    on:click|preventDefault|stopPropagation={changeCarouselPositionNext}
                    on:keydown={changeCarouselPositionNext}
                    class="section-action">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g id="Icon/Solid/Arrowhead/Right">
                        <path
                          id="Arrow"
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M4.23178 1.41981C3.87821 1.9148 3.93554 2.65046 4.35982 3.06295L9.43795 8L4.35982 12.9371C3.93554 13.3495 3.87821 14.0852 4.23178 14.5802C4.58534 15.0752 5.21591 15.1421 5.64018 14.7296L11.6402 8.89625C11.8682 8.6746 12 8.34624 12 8C12 7.65376 11.8682 7.3254 11.6402 7.10375L5.64018 1.27044C5.21591 0.857947 4.58534 0.924825 4.23178 1.41981Z"
                          fill="#1A1A1A" />
                      </g>
                    </svg>
                  </div>
                {/if}
              </div>
            </div>
          {:else}
            <Button class="finish-btn" text="Finish!" on:click={markAsFinished} disabled={!finishButtonEnabled} />
          {/if}
        </div>
      {:else}
        <div class="top-section">
          <div class="title">
            <img class="worker-women" src={quiz.emoji} alt="" />
            <div class="heading">
              {quiz.heading}
            </div>
            <img
              on:click|preventDefault|stopPropagation={toggleExpand}
              on:keydown={toggleExpand}
              class="icon-arrow"
              src="/images/quiz/arrow.png"
              alt="" />
          </div>
        </div>
      {/if}
    {:else}
      <div class="arrow-action" style="margin-left: 4px;">
        <img
          src="/images/quiz/arrow.png"
          alt=""
          on:click|preventDefault|stopPropagation={toggleExpand}
          on:keydown={toggleExpand} />
      </div>
      <img class="worker-women" width={24} src={quiz.emoji} alt="" />
    {/if}
  </div>
{/if}
